import { render, staticRenderFns } from "./selected_pack.vue?vue&type=template&id=4b4996f4&"
import script from "./selected_pack.vue?vue&type=script&lang=js&"
export * from "./selected_pack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports